export const ATTR_DATA_KIND = 'data-kind';
export const ATTR_DATA_TYPE = 'data-type';
export const ATTR_DATA_ID = 'data-id';
export const TOP_LAYER = 'top';
export const DEFAULT_LAYER = 'default';
export const GROUPS_LAYER = 'groups';
export const BOTTOM_LAYER = 'bottom';
export const DEFAULT_LAYERS = [BOTTOM_LAYER, GROUPS_LAYER, DEFAULT_LAYER, TOP_LAYER];
//# sourceMappingURL=const.js.map